module.exports = __webpack_public_path__ + "img/web2icon4.b8522713.png";